import React from 'react';

const languages = [
  { code: 'en', name: '🇮🇳 English' },
  { code: 'hi', name: '🇮🇳 Hindi' },
  { code: 'as', name: '🇮🇳 Assamese' },
  { code: 'bn', name: '🇮🇳 Bengali' },
  { code: 'gu', name: '🇮🇳 Gujarati' },
  { code: 'kn', name: '🇮🇳 Kannada' },
  { code: 'ml', name: '🇮🇳 Malayalam' },
  { code: 'mr', name: '🇮🇳 Marathi' },
  { code: 'or', name: '🇮🇳 Odia (Oriya)' },
  { code: 'pa', name: '🇮🇳 Punjabi (Gurmukhi)' },
  { code: 'ta', name: '🇮🇳 Tamil' },
  { code: 'te', name: '🇮🇳 Telugu' },
  { code: 'ur', name: '🇮🇳 Urdu' }
];

const LanguageSelector = () => {
  const handleLanguageChange = (e) => {
    const lang = e.target.value;
    const select = document.querySelector('.goog-te-combo');
    if (select) {
      select.value = lang;
      select.dispatchEvent(new Event('change'));
    }
  };

  return (
    <div style={{ margin: '1rem 0', display: 'flex', justifyContent: 'center' }}>
      <select
        onChange={handleLanguageChange}
        defaultValue=""
        style={{
          padding: '6px 10px',
          fontSize: '14px',
          borderRadius: '6px',
          border: '1px solid #ccc',
          backgroundColor: '#f9f9f9',
          cursor: 'pointer',
          width: '150px'
        }}
      >
        <option value="">🌐 Select Language</option>
        {languages.map(lang => (
          <option key={lang.code} value={lang.code}>
            {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
